<template>
  <div>
    <div class="ui segment" style="background-color: #f6feff">
      <el-row>
        <el-col :span="24">
          <el-radio
            v-model="deliveryMethod"
            label="shipped"
            @change="onShippingMethodChange"
            :disabled="isShippingDisabled"
            ><span style="font-size: 15px;">{{
              isShippingDisabled ? "Shipped (unavailable)" : "Shipped"
            }}</span></el-radio
          >
          <el-radio
            v-model="deliveryMethod"
            label="pickup"
            @change="onShippingMethodChange"
            :disabled="isPickupDisabled"
            ><span style="font-size: 15px;">{{
              isPickupDisabled ? "School Pickup (unavailable)" : "School Pickup"
            }}</span></el-radio
          >
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "DeliveryMethod",
  data() {
    return {
      deliveryMethod: ""
    };
  },
  props: {
    order: {
      type: Object,
      required: true
    },
    canChangeDeliveryMethod: {
      type: Boolean,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    isForSchoolPickup() {
      return this.order.is_for_school_pickup;
    },
    isShipped() {
      return this.order.is_shipped;
    },
    isPickupDisabled() {
      if (this.isShipped && !this.canChangeDeliveryMethod) {
        return true;
      }
      return false;
    },
    isShippingDisabled() {
      if (this.isForSchoolPickup && !this.canChangeDeliveryMethod) {
        return true;
      }
      return false;
    }
  },
  methods: {
    onShippingMethodChange() {
      console.log(this.deliveryMethod);
      this.$emit("deliveryMethodChanged", this.deliveryMethod);
    }
  },
  mounted() {
    if (this.isForSchoolPickup) {
      this.deliveryMethod = "pickup";
    } else if (this.isShipped) {
      this.deliveryMethod = "shipped";
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../styles/sass/cart.scss";
</style>
